<template>
  <div class="mingyue-page">
		<div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    <div class="banner mingyue_banner">
			<div class="bodyinfo">
				<h2 style="width: 432px;">微震监测平台</h2>
				<p>全球动力型灾害微震在线监测分析管理平台是一个综合管理软件</p>
				<!-- <a href="javascript:;" class="case-see-more-btn">查看更多</a> -->
			</div>
		</div>
		<div class="mingyue_body microseismic_body">
      <div class="" style=" background: #FFFFFF; padding-top: 150px; padding-bottom: 485px;">
        <div class="caseDetails-center-content-container" style="width: 70%; margin: 0 auto;">
          <p class="introduce-item-title">案例介绍</p>
          <p class="introduce-item-describe" style="text-align: left; color: #344455; line-height: 36px;">全球动力型灾害微震在线监测分析管理平台是一个综合管理软件。实现对现有单个工程项目的数据、设备进行统一集中管理与展示，采集监测数据，三维模型展示，各种图表进行分析。并且建立数据分析任务分发系统，增加对数据的共享性，实现数据分析任务的高效完成。</p>
        </div>
      </div>
			<div class="mingyue1">
				<div class="top">
					<img class="img1" src="../../assets/img/caseDetails/microseismic/default_img3.png">
					<span class="span1">GMD管理模块,完成分析采集事件集,预测震级突发段</span>
					<span class="span2">实时监控各个工程点位的状况</span>
				</div>
			</div>
			<div class="mingyue2">
				<span class="span1">波形数据展示</span>
				<img class="img2" src="../../assets/img/caseDetails/microseismic/default_img2.png">
				<img class="img1" src="../../assets/img/caseDetails/microseismic/default_img4.png">
			</div>
			<div class="mingyue3">
				<h2>微震监测平台</h2>
			</div>
			<div class="mingyue4">	
				<img class="img2" src="../../assets/img/caseDetails/microseismic/default_img1.png">
				<span class="span1">分析端界面展示</span>
			</div>
		</div>
		<Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'

export default {
  name: 'microseismic',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {

    }
  },
  mounted() {
  },
}
</script>
<style  scoped>
  @import '../../html/css/zkm.css';
  @import '../../html/css/zkm.market.css';

  .microseismic_body .mingyue1{
    height: 560px;
  }
  .microseismic_body .mingyue1 .img1{
    top: -433px;
    width: 73%;
    margin-left: -37%;
  }
  .microseismic_body .mingyue1 .span1{
    font-size: 30px;
    color: #222222;
    width: 364px;
    top: -257px;
    right: 50%;
    margin-right: -578px;
  }
  .microseismic_body .mingyue1 .span2{
    font-size: 30px;
    color: #222222;
    top: auto;
    bottom: 75px;
    margin-right: 121px;
  }
  .microseismic_body .mingyue4{
    height: auto;
    padding: 138px 0px 200px;
    display:-webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .microseismic_body .mingyue4 .img2{
    width: 63%;
    margin-left: 0px;
    position: static;
  }
  .microseismic_body .mingyue4 .span1{
    position: absolute;
    top: 0px;
    left: 50%;
    margin-left: -32%;
    margin-top: 311px;
    display: inline-block;
    width: 30px;
    font-size: 26px;
    color: #2E4050;
    font-weight: normal;
  }
  .microseismic_body .mingyue2{
    height: 814px;
  }
  .microseismic_body .mingyue2 .span1{
    font-size: 38px;
    font-weight: normal;
    color: #2E4050;
    margin-right: 288px;
  }
  .microseismic_body .mingyue2 .img1{
    margin-left: -8%;
  }
  .microseismic_body .mingyue2 .img2{
    margin-right: -8%;
  }
  .microseismic_body .mingyue3 h2{
    font-size: 38px;
    padding-top: 255px;
  }
</style>